import Container from "../components/common/Container";
import CompaniesTable from "../components/Companies/Table";
import PageHeader from "../components/common/PageHeader";
import { useLocation, useNavigate } from "react-router";

const Companies = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Container>
      <PageHeader
        title="Şirketler"
        isButtoned
        buttonText="Yeni Şirket"
        buttonOnClick={() => {
          navigate(`${location.pathname}/new`);
        }}
      />
      <CompaniesTable />
    </Container>
  );
};

export default Companies;
